import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { player } from 'src/client/player';
import { useStores } from 'src/common/providers';
import secondsToTime from 'src/common/utils/secondsToTime';
import { selectIsMobile } from '../../../../selectors/app';
import DefaultScrubber from './DefaultScrubber';
import LiveSeekScrubber from './LiveSeekScrubber';

const sliderMax = 100;

export default function Scrubber({ isInNowPlayingDialog, className }) {
  const { playerStore } = useStores();
  const metadata = playerStore.metadata();
  const isVideoAdLoaded = playerStore.isVideoAdLoaded();
  const isMobile = useSelector(selectIsMobile);
  const duration = playerStore.duration();
  const currentTime = playerStore.currentTime();
  // `isUnboundedStream` is the browser-independent "true live station, not scrubbable" flag; the DefaultScrubber uses
  // it to hide timestamps and disable the slider. `isLive` is the engine's live-edge notion: for a live-seek stream
  // it becomes false once the user scrubs back from the head, which is what the LiveSeekScrubber uses for GO LIVE.
  // Ads keep both indicators in their "live" state.
  const isUnboundedStream = (metadata?.isUnboundedStream ?? true) || isVideoAdLoaded;
  const isAtLiveEdge = (metadata?.isLive ?? true) || isVideoAdLoaded;
  const newPositionInfo = {
    duration,
    elapsedSeconds: currentTime,
    elapsedPercent: duration ? (currentTime / duration) * 100 : 0,
    isLiveSeekStream: metadata?.isLiveSeek,
  };

  const { elapsedSeconds = 0, elapsedPercent = 0, isLiveSeekStream } = newPositionInfo;
  const elapsedTime = secondsToTime(elapsedSeconds);
  const durationTime = secondsToTime(duration);

  if (isLiveSeekStream && !isMobile) {
    return (
      <LiveSeekScrubber
        isLive={isAtLiveEdge}
        sliderMax={sliderMax}
        elapsedTime={elapsedTime}
        durationTime={durationTime}
        elapsedPercent={elapsedPercent}
        elapsedSeconds={elapsedSeconds}
        onChangeCommitted={player.seekTo}
      />
    );
  }

  return (
    <DefaultScrubber
      sliderMax={sliderMax}
      elapsedTime={elapsedTime}
      durationTime={durationTime}
      elapsedPercent={elapsedPercent}
      elapsedSeconds={elapsedSeconds}
      onChangeCommitted={player.seekTo}
      isInNowPlayingDialog={isInNowPlayingDialog}
      className={className}
      isLive={isUnboundedStream}
    />
  );
}

Scrubber.propTypes = {
  isInNowPlayingDialog: PropTypes.bool,
  className: PropTypes.string,
};
